import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Payout.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListTranslationPage - Lazy-loaded ListPayoutPage component.
 */
const PayoutListPage = Loadable(lazy(() => import("./ListPayoutPage")));

/**
 * Array containing route definitions for the Payout-related pages.
 * @constant {Object[]} PayoutPageRoutes - Array of Payout route objects.
 * @property {React.ReactElement} PayoutPageRoutes[].element - The React element to be rendered for the Payout route.
 */
const PayoutPageRoutes = [
  {
    path: "list",
    element: <PayoutListPage />,
  },
];

export default PayoutPageRoutes;
